(() => {
  function visibleElement(el) {
    if (!el) return false;
    const style = window.getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden' && !el.disabled;
  }

  function findBuyButton() {
    const selectors = [
      'product-form button[name="add"]',
      'form[action*="/cart/add"] button[name="add"]',
      'add-to-cart button',
      '[data-testid="add-to-cart"] button',
      'button[name="add"]'
    ];
    for (const selector of selectors) {
      const button = Array.from(document.querySelectorAll(selector)).find(visibleElement);
      if (button) return button;
    }
    return null;
  }

  function openInquiry() {
    const inquiry = document.querySelector('.ja-visible-inquiry');
    if (!inquiry) return;
    const details = inquiry.querySelector('details');
    if (details) details.open = true;
    inquiry.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-ja-mobile-primary-action]');
    if (!trigger) return;
    event.preventDefault();

    const bar = trigger.closest('[data-ja-mobile-product-cta]');
    const available = bar && bar.getAttribute('data-product-available') === 'true';

    if (!available) {
      openInquiry();
      return;
    }

    const buyButton = findBuyButton();
    if (buyButton) {
      buyButton.click();
    } else {
      const productForm = document.querySelector('product-form, form[action*="/cart/add"]');
      if (productForm) productForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });
})();
